import React from 'react'
type PricingComponentProps = {
    data: {
        heading: string,
        mainContent: {
            title: string,
            sub: string,
            color?: string
        }[]
    },
    value: string
}
export default function PricingComponent({ data, value }: PricingComponentProps) {
    return (
        <div className="pricing_feature-comp" style={{ marginBottom: value }} >
            <h1>{data?.heading}</h1>
            <ul>
                {
                    data?.mainContent.map((item, index) => {
                        return <li key={index}>
                            <p>{item.title}</p>
                            {
                                item?.color ? <span style={{ color: item?.color }}>{item.sub}</span> : <span>{item.sub}</span>
                            }

                        </li>
                    })
                }


            </ul>
        </div>
    )
}
